var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPushpinLine = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21868 1.8855L14.876 7.54283L13.9327 8.4855L13.4613 8.01416L10.6333 10.8422L10.162 13.1995L9.21868 14.1422L6.39068 11.3135L3.09068 14.6135L2.14801 13.6708L5.44801 10.3708L2.61934 7.54283L3.56201 6.5995L5.92001 6.12817L8.74801 3.30016L8.27668 2.82883L9.21934 1.8855H9.21868ZM9.69068 4.24283L6.57668 7.35617L4.69534 7.73283L9.02868 12.0662L9.40468 10.1848L12.5187 7.0715L9.69068 4.24283V4.24283Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPushpinLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pushpin-line.aaea70955cb9f0b563bb82a90ae88867.svg";